import { Label } from "@/components/ui/label";
import { Slider } from "@/components/ui/slider";
import { KB_TOP_K_MAX, KB_TOP_K_MIN } from "@/utils/kb-results-per-search";

interface KbResultsPerSearchProps {
  value: number;
  onChange: (value: number) => void;
}

/** How many matches one knowledge-base search gives the agent (`config.kbTopK`, saved on Publish). */
export function KbResultsPerSearch({ value, onChange }: KbResultsPerSearchProps) {
  return (
    <div className="space-y-2 pt-4 border-t">
      <Label>Results per search: {value}</Label>
      <Slider value={[value]} onValueChange={([next]) => onChange(next)} min={KB_TOP_K_MIN} max={KB_TOP_K_MAX} step={1} />
      <p className="text-xs text-muted-foreground">
        More: the agent also gets matches that are less close, where the answer sometimes is. Fewer: it gets only the
        closest ones.
      </p>
    </div>
  );
}
